import * as React from 'react';
import classNames from 'classnames';
import { RegionDropdown } from '../../containers/RegionDropdown';
import { RoomsCheckbox } from '../../containers/RoomsCheckbox';
import { PriceInput } from '../../containers/PriceInput';
import { AreaInput } from '../../containers/AreaInput';
import { DeadlineDropdown } from '../../containers/DeadlineDropdown';
import { ReadyApartments } from '../../containers/ReadyApartments';
import { ApartmentsWithDecoration } from '../../containers/ApartmentsWithDecoration';
import * as styles from './Filters.css';

export function Filters() {
  return (
    <article className={styles['filters']}>
      <div className={classNames(styles['filters__control'], styles['filters__control_mb'])}>
        <RegionDropdown />
      </div>
      <div className={classNames(styles['filters__control'], styles['filters__control_mb'])}>
        <RoomsCheckbox />
      </div>
      <div className={classNames(styles['filters__control'], styles['filters__control_mb'])}>
        <PriceInput />
      </div>
      <div className={classNames(styles['filters__control'], styles['filters__control_mb'])}>
        <AreaInput />
      </div>
      <div className={classNames(styles['filters__control'], styles['filters__control_mb'])}>
        <DeadlineDropdown />
      </div>
      <div className={classNames(styles['filters__control'], styles['filters__control_mb'])}>
        <ReadyApartments />
      </div>
      <div className={styles['filters__control']}>
        <ApartmentsWithDecoration />
      </div>
    </article>
  );
}
